/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-23 08:48:52
 **/

import { useRef } from "react";

import ChatServiceAPI from "../ChatServiceAPI";

export default function withChat(events: API.Events) {
	const service = useRef(ChatServiceAPI.getInstance(events));

	return {
		sendMessage: service.current.chat.sendMessage,
		deleteMessages: service.current.chat.deleteMessages,
		updateMessage: service.current.chat.updateMessage,
		messages: service.current.chat.messages,
		searchMessages: service.current.chat.searchMessages,
		getRoomView: service.current.chat.roomView,
		updateView: service.current.chat.updateRoomView,
		getRoom: service.current.chat.getRoom,
		pinRoom: service.current.chat.pinRoom,
		searchUser: service.current.chat.searchUser,
		messageReaded: service.current.chat.messageReaded,
		messageReadAll: service.current.chat.messageReadAll,
		notification: service.current.chat.updateNotification,
		getThread: service.current.chat.getThread,
		threadReaded: service.current.chat.readThread,
		reaction: {
			add: service.current.chat.reaction.add,
			remove: service.current.chat.reaction.remove
		},
		deleteFile: service.current.chat.deleteFile,
		dm: {
			list: service.current.chatDM.list,
			create: service.current.chatDM.create,
			addUsers: service.current.chatDM.addUsers,
			hide: service.current.chatDM.hide,
			checkExist: service.current.chatDM.checkExist,
			checkAuth: service.current.chatDM.checkAuth
		},
		space: {
			list: service.current.chatSpace.list,
			create: service.current.chatSpace.create,
			addUsers: service.current.chatSpace.addUsers,
			inquiry: service.current.chatSpace.inquiry,
			delete: service.current.chatSpace.remove,
			leave: service.current.chatSpace.leave,
			topBarColor: service.current.chatSpace.topBarColor,
			update: service.current.chatSpace.update,
			groupedList: service.current.chatSpace.groupedList,
			join: service.current.chatSpace.join
		},
		notice: {
			register: service.current.chatNotify.register,
			remove: service.current.chatNotify.remove
		},
		changeOwner: service.current.chat.changeOwner,
		vote: {
			detail: service.current.chatVote.detail,
			delete: service.current.chatVote.deleteVote,
			create: service.current.chatVote.create,
			end: service.current.chatVote.end,
			choose: service.current.chatVote.choose,
			update: service.current.chatVote.update
		},
		alarmNotification: {
			inquiry: service.current.chatAlarmNotification.inquery
		},
		activity: {
			getActivities: service.current.chatActivity.getActivities,
			getActivity: service.current.chatActivity.getActivity
		},
		bookmark: {
			add: service.current.chat.bookmark.add,
			remove: service.current.chat.bookmark.remove
		}
	};
}
